export function checkedPaperCode(raw: string, task: { kind?: string; source_code?: string }) {
  const code = raw.trim();
  if (!code || code.length > 4096) throw Error('Mã QR không hợp lệ. Hãy quét lại nhãn trên giấy.');
  if (task.kind === 'TEST' && task.source_code && code !== task.source_code)
    throw Error('QR này không thuộc nhãn mẫu đang chờ xác nhận. Hãy quét đúng nhãn của lần in này.');
  return code;
}
